/* Restore the original in-view count-up without loading the source store runtime. */
(() => {
  if (customElements.get('impact-text')) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  // Original easing: cubic-bezier(.16, 1, .3, 1).
  const ease = x => {
    let lo = 0, hi = 1;
    for (let i = 0; i < 18; i++) {
      const t = (lo + hi) / 2, u = 1 - t;
      if (3 * u * u * t * .16 + 3 * u * t * t * .3 + t * t * t < x) lo = t; else hi = t;
    }
    return 1 - Math.pow(1 - (lo + hi) / 2, 3);
  };
  class ImpactText extends HTMLElement {
    connectedCallback() {
      if (this.done || reduced.matches) return;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect(); this.done = true; this.start();
        }
      }, {rootMargin: '-100px 0px', threshold: 0});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect(); cancelAnimationFrame(this.frame);
      this.finish?.(); this.reveal?.cancel();
    }
    start() {
      this.reveal = this.animate([{opacity: 1, transform: 'translateY(10px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 300});
      if (!this.hasAttribute('count-up')) return;
      const host = this.firstElementChild || this;
      const walker = document.createTreeWalker(host, NodeFilter.SHOW_TEXT);
      let node, match;
      while ((node = walker.nextNode())) {
        match = node.textContent.match(/\d+(?:[, .]\d+)*/);
        if (match) break;
      }
      if (!match) return;
      const original = match[0], end = Number(original.replace(/[, .]/g, ''));
      const duration = Number(this.getAttribute('count-up')) * 1000;
      if (!Number.isFinite(end) || !(duration > 0)) return;
      const number = document.createElement('span');
      number.textContent = original;
      const after = node.splitText(match.index); after.splitText(original.length); after.replaceWith(number);
      number.style.display = 'inline-block'; number.style.textAlign = 'end';
      number.style.minWidth = number.getBoundingClientRect().width + 'px';
      this.finish = () => {number.textContent = original; number.style.minWidth = '';};
      const start = performance.now(); number.textContent = '0';
      const tick = now => {
        const progress = Math.min(1, (now - start) / duration);
        if (progress >= 1 || reduced.matches) {this.finish(); return;}
        number.textContent = String(Math.round(end * ease(progress)));
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
  }
  customElements.define('impact-text', ImpactText);
})();
